import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["calendars", "containerStyle", "inputFormat", "inputRef", "label", "onChange", "onResetFilter", "placeholder", "fieldError", "minDate", "maxDate", "isLargeScreen", "shouldDisableDate", "renderInput", "textFieldProps", "value", "wrapper", "color", "ampmButton", "weekOfDayButton", "onChangAmPm", "onChangesetWeekOfDay"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import MuiDateRangePickerDay, { dateRangePickerDayClasses } from '@mui/lab/DateRangePickerDay';
import { DesktopDateRangePicker } from '@mui/lab';
import { FormControl, IconButton, InputAdornment, styled } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import TAGPickerFilterTabContent from './TAGPickerFilterTabContent';
import TAGDateRangeCalendar from './TAGDateRangeCalendar';
import { disableSunday } from './TAGPicker.type';
import TAGPickerWrapper from './TAGPickerWrapper';
import TAGPickerTabs from './TAGPickerTabs';
import { transformedColor } from '../../../constants/themehelper';
import TAGTextFieldInput from '../TAGInput/TAGTextFieldInput';

var TAGDateRangePicker = function TAGDateRangePicker(_ref) {
  var _ref$calendars = _ref.calendars,
      calendars = _ref$calendars === void 0 ? 1 : _ref$calendars,
      containerStyle = _ref.containerStyle,
      _ref$inputFormat = _ref.inputFormat,
      inputFormat = _ref$inputFormat === void 0 ? 'iii MMM dd, yyyy' : _ref$inputFormat,
      inputRef = _ref.inputRef,
      label = _ref.label,
      _onChange = _ref.onChange,
      onResetFilter = _ref.onResetFilter,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? 'Select a date or range' : _ref$placeholder,
      _ref$fieldError = _ref.fieldError,
      fieldError = _ref$fieldError === void 0 ? false : _ref$fieldError,
      _ref$minDate = _ref.minDate,
      minDate = _ref$minDate === void 0 ? new Date() : _ref$minDate,
      _ref$maxDate = _ref.maxDate,
      maxDate = _ref$maxDate === void 0 ? undefined : _ref$maxDate,
      isLargeScreen = _ref.isLargeScreen,
      shouldDisableDate = _ref.shouldDisableDate,
      renderInput = _ref.renderInput,
      textFieldProps = _ref.textFieldProps,
      value = _ref.value,
      _ref$wrapper = _ref.wrapper,
      wrapper = _ref$wrapper === void 0 ? 'Dialog' : _ref$wrapper,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'secondary' : _ref$color,
      ampmButton = _ref.ampmButton,
      weekOfDayButton = _ref.weekOfDayButton,
      onChangAmPm = _ref.onChangAmPm,
      onChangesetWeekOfDay = _ref.onChangesetWeekOfDay,
      props = _objectWithoutProperties(_ref, _excluded);

  var _React$useState = React.useState([null, null]),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      tempArrayValue = _React$useState2[0],
      settempArrayValue = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      open = _React$useState4[0],
      setOpen = _React$useState4[1];

  var screenMatches = isLargeScreen !== undefined ? isLargeScreen : useMediaQuery('(min-width:500px)');

  var onOpen = function onOpen() {
    return setOpen(true);
  };

  var onClose = function onClose() {
    return setOpen(false);
  };

  var onClear = function onClear() {
    _onChange([new Date(), new Date()]);

    settempArrayValue([null, null]);

    if (!isLargeScreen) {
      onResetFilter && onResetFilter();
    }
  };

  var onAccept = function onAccept() {
    _onChange(tempArrayValue);

    setOpen(false);
  };

  var onSetToday = function onSetToday() {
    _onChange([new Date(), new Date()]);

    setOpen(false);
  };

  var onChangeTempArrayValue = function onChangeTempArrayValue(newValue) {
    return settempArrayValue(newValue);
  };

  var tabData = [{
    label: 'range',
    content: React.createElement(TAGDateRangeCalendar, {
      color: color,
      displayStaticWrapperAs: 'desktop',
      tempArrayValue: tempArrayValue,
      onChange: onChangeTempArrayValue,
      minDate: minDate,
      maxDate: maxDate
    })
  }, {
    label: 'filter',
    content: React.createElement(TAGPickerFilterTabContent, {
      color: color,
      ampmButton: ampmButton,
      onChangAmPm: onChangAmPm,
      onChangesetWeekOfDay: onChangesetWeekOfDay,
      weekOfDayButton: weekOfDayButton,
      sx: {
        padding: '20px'
      }
    })
  }];
  var DateRangePickerDay = styled(MuiDateRangePickerDay)(function (_ref2) {
    var isEndOfHighlighting = _ref2.isEndOfHighlighting,
        isHighlighting = _ref2.isHighlighting,
        isStartOfHighlighting = _ref2.isStartOfHighlighting,
        theme = _ref2.theme;
    return _objectSpread(_objectSpread(_objectSpread({}, isHighlighting && {
      padding: 1,
      borderRadius: 0,
      backgroundColor: '#F2F3F4' // color: transformedColor(color),
      // '&:hover, &:focus': {
      //   background:
      //     color &&
      //     theme.palette[color.split('.')[0] as keyof Palette][
      //       (color.split('.')[1] || 'main') as keyof PaletteColorOptions
      //     ],
      // },

    }), isStartOfHighlighting && {
      borderTopLeftRadius: '50%',
      borderBottomLeftRadius: '50%',
      background: color && theme.palette[color.split('.')[0]][color.split('.')[1] || 'main'],
      color: 'white'
    }), isEndOfHighlighting && {
      borderTopRightRadius: '50%',
      borderBottomRightRadius: '50%',
      background: color && theme.palette[color.split('.')[0]][color.split('.')[1] || 'main'],
      color: 'white'
    });
  });

  var renderDateRangePickerDay = function renderDateRangePickerDay(_date, dateRangePickerDayProps) {
    return React.createElement(DateRangePickerDay, _objectSpread(_objectSpread({}, dateRangePickerDayProps), {}, {
      sx: _defineProperty({}, "&&.".concat(dateRangePickerDayClasses.root), {
        '&& .Mui-selected': {
          backgroundColor: transformedColor(color),
          color: 'white'
        }
      })
    }));
  };

  var CalendarIcon = function CalendarIcon() {
    return React.createElement(InputAdornment, {
      position: "end"
    }, React.createElement(IconButton, {
      onClick: onOpen
    }, React.createElement(CalendarTodayIcon, {
      className: "CalendarTodayIcon",
      sx: {
        color: transformedColor(color)
      }
    })));
  };

  var rendeDateValue = function rendeDateValue(startProps, endProps) {
    var _startProps$inputProp, _endProps$inputProps, _startProps$inputProp2, _endProps$inputProps2, _startProps$inputProp3, _startProps$inputProp4, _endProps$inputProps3, _startProps$inputProp5, _startProps$inputProp6, _endProps$inputProps4;

    startProps.label = '';
    endProps.label = '';

    switch (true) {
      case !((_startProps$inputProp = startProps.inputProps) !== null && _startProps$inputProp !== void 0 && _startProps$inputProp.value) && !((_endProps$inputProps = endProps.inputProps) !== null && _endProps$inputProps !== void 0 && _endProps$inputProps.value):
        return '';

      case ((_startProps$inputProp2 = startProps.inputProps) === null || _startProps$inputProp2 === void 0 ? void 0 : _startProps$inputProp2.value) === ((_endProps$inputProps2 = endProps.inputProps) === null || _endProps$inputProps2 === void 0 ? void 0 : _endProps$inputProps2.value):
        return "".concat(((_startProps$inputProp3 = startProps.inputProps) === null || _startProps$inputProp3 === void 0 ? void 0 : _startProps$inputProp3.value) || startProps.label);

      case ((_startProps$inputProp4 = startProps.inputProps) === null || _startProps$inputProp4 === void 0 ? void 0 : _startProps$inputProp4.value) && !((_endProps$inputProps3 = endProps.inputProps) !== null && _endProps$inputProps3 !== void 0 && _endProps$inputProps3.value):
        return "".concat(((_startProps$inputProp5 = startProps.inputProps) === null || _startProps$inputProp5 === void 0 ? void 0 : _startProps$inputProp5.value) || startProps.label);

      default:
        return "".concat(((_startProps$inputProp6 = startProps.inputProps) === null || _startProps$inputProp6 === void 0 ? void 0 : _startProps$inputProp6.value) || startProps.label, " - ").concat(((_endProps$inputProps4 = endProps.inputProps) === null || _endProps$inputProps4 === void 0 ? void 0 : _endProps$inputProps4.value) || endProps.label);
    }
  };

  var renderInputField = function renderInputField(startProps, endProps) {
    return (// <TAGPickerTextField
      //   // {...textFieldProps}
      //   style={containerStyle}
      //   value={rendeDateValue(startProps, endProps)}
      //   fullWidth
      //   color={color}
      //   // color={color}
      //   variant={variant}
      //   InputProps={{
      //     endAdornment: <CalendarIcon />,
      //   }}
      //   label={label}
      //   error={fieldError}
      //   placeholder={placeholder}
      // />
      React.createElement(TAGTextFieldInput, _objectSpread(_objectSpread({}, textFieldProps), {}, {
        style: containerStyle,
        value: rendeDateValue(startProps, endProps),
        fullWidth: true,
        // color={cleanColorName(color)}
        color: color,
        endAdornment: React.createElement(CalendarIcon, null),
        inputLabel: label,
        fieldError: fieldError,
        fieldPlaceHolder: placeholder
      }))
    );
  };

  return React.createElement(LocalizationProvider, {
    dateAdapter: AdapterDateFns
  }, React.createElement(FormControl, {
    fullWidth: true
  }, React.createElement(DesktopDateRangePicker, _objectSpread(_objectSpread({}, props), {}, {
    minDate: minDate,
    maxDate: maxDate,
    renderDay: renderDateRangePickerDay,
    ref: inputRef,
    value: value,
    open: wrapper === 'Popper' && open && screenMatches,
    onChange: function onChange(newValue) {
      open && _onChange(newValue);
    },
    onClose: onClose,
    inputFormat: inputFormat,
    shouldDisableDate: shouldDisableDate || disableSunday,
    calendars: calendars,
    renderInput: renderInput !== undefined ? renderInput : renderInputField
  })), React.createElement(TAGPickerWrapper, {
    screenMatch: screenMatches,
    onOpen: onOpen,
    onClose: onClose,
    onAccept: onAccept,
    onSetToday: onSetToday,
    onClear: onClear,
    drawerChildren: React.createElement(TAGPickerTabs, {
      tabData: tabData
    }),
    wrapper: wrapper,
    open: open,
    color: color
  }, React.createElement(TAGDateRangeCalendar, {
    color: color,
    displayStaticWrapperAs: 'mobile',
    tempArrayValue: tempArrayValue,
    onChange: onChangeTempArrayValue,
    minDate: minDate,
    maxDate: maxDate
  }))));
};

export default TAGDateRangePicker;